interface FilterChipsProps {
  options: string[];
  selected: string | null;
  onSelect: (value: string | null) => void;
  allLabel?: string;
}

/**
 * Not a formally-specified docs/DESIGN_SYSTEM.md component, but built from
 * the same primitives (rounded-sm, border-subtle, accent-on-active) as
 * everything else — a small, consistent addition for category filtering.
 */
export function FilterChips({ options, selected, onSelect, allLabel = 'All' }: FilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by category">
      <button
        type="button"
        onClick={() => onSelect(null)}
        className={[
          'px-3 py-1.5 min-h-[44px] rounded-sm text-small border transition-colors',
          selected === null
            ? 'bg-accent-management-50 border-accent-management-border text-accent-management-400'
            : 'border-border-subtle text-text-secondary hover:text-text-primary hover:border-border',
        ].join(' ')}
      >
        {allLabel}
      </button>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onSelect(option)}
          className={[
            'px-3 py-1.5 min-h-[44px] rounded-sm text-small border transition-colors',
            selected === option
              ? 'bg-accent-management-50 border-accent-management-border text-accent-management-400'
              : 'border-border-subtle text-text-secondary hover:text-text-primary hover:border-border',
          ].join(' ')}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
